(function () {
    'use strict';

    var patterns = [
        /^\/tag\//i,
        /^\/category\//i,
        /[?&\/]PgrID[=\/]/i,
        /[?&\/]PageID[=\/]/i,
        /[?&\/]PID[=\/]/i,
        /[?&\/]TagID[=\/]/i,
        /[?&\/]TagName[=\/]/i
    ];

    var url = window.location.pathname + window.location.search;

    for (var i = 0; i < patterns.length; i++) {
        if (patterns[i].test(url)) {
            var meta = document.getElementById('MetaRobots');
            if (meta) {
                meta.setAttribute('content', 'noindex, nofollow');
            } else {
                meta = document.createElement('meta');
                meta.setAttribute('name', 'robots');
                meta.setAttribute('content', 'noindex, nofollow');
                document.head.insertBefore(meta, document.head.firstChild);
            }
            break;
        }
    }

}());
